module.exports = "/images/vendor/desiigner-svg/svg/ui/medal.svg?d3efc4633831ddbaf2fa80737b029874";